import { Action, Reducer } from 'redux'
import { IFMCSAInfo, ICarrierFMCSAState } from 'types/carrier'
import { FMCSA_ACTION_TYPES } from 'utils/actions/carrier'

interface ErrorAction extends Action<string> {
  error: string
}

interface SuccessAction extends Action<string> {
  payload: {
    fmcsaCarrierInformation: IFMCSAInfo
  }
}

type FMCSAAction = Action<string> | ErrorAction | SuccessAction

const { FMCSA_FAILURE, FMCSA_REQUEST, FMCSA_SUCCESS } = FMCSA_ACTION_TYPES

const defaultState = {
  fmcsaInfo: undefined,
  loading: false,
  error: undefined,
} as ICarrierFMCSAState

const fmcsaReducer: Reducer<ICarrierFMCSAState, FMCSAAction> = (state = defaultState, action) => {
  if (!action) return state

  switch (action.type) {
    case FMCSA_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined,
      }
    case FMCSA_SUCCESS:
      return {
        ...state,
        loading: false,
        fmcsaInfo: (action as SuccessAction).payload.fmcsaCarrierInformation,
      }
    case FMCSA_FAILURE:
      return {
        ...state,
        loading: false,
        error: (action as ErrorAction).error,
      }
    default:
      return state
  }
}

export default fmcsaReducer
